import { FC } from 'react';
import { getOfflineInstructionsByPledgeMethod } from 'helpers/donate';
import { IPage } from 'store/donatePage/types';
import { PaymentMethodType } from 'store/pay/types';

interface Props {
  isWireEnabled?: boolean;
  isRecurring: boolean;
  showAllDonateMethods: boolean;
  donateMethod?: string;
  page?: IPage;
  getOnDonateButtonClick: (method: string, type: string) => () => void;
}

export const PledgeDonateButtons: FC<Props> = ({
  isWireEnabled,
  isRecurring,
  showAllDonateMethods,
  donateMethod,
  page,
  getOnDonateButtonClick,
}) => {
  // Offline methods send donors to instructions rather than completing a payment, so these
  // labels intentionally describe that instead of using the page's custom action verb.
  const offlineMethods = [
    {
      method: 'wire' as PaymentMethodType,
      label: 'ACCESS WIRE INSTRUCTIONS',
    },
    {
      method: 'check' as PaymentMethodType,
      label: 'ACCESS CHECK INSTRUCTIONS',
    },
    {
      method: 'grant' as PaymentMethodType,
      label: 'ACCESS GRANT INSTRUCTIONS',
    },
  ];

  // isWireEnabled is used to reflect the value we get from the pages API response, wire_enabled
  // it reflects if pledge donations are enabled for the page
  // the variable name will be updated to isPledgeEnabled in the future when the DB column and API response are updated
  if (!isWireEnabled || isRecurring || (!showAllDonateMethods && donateMethod !== 'pledge')) {
    return null;
  }
  return (
    <>
      {offlineMethods.map(
        offlineMethod =>
          getOfflineInstructionsByPledgeMethod(page, offlineMethod.method)?.length > 0 && (
            <div key={offlineMethod.method} className="display-flex justify-around">
              <button
                type="button"
                className="button-brand donate-button split-screen"
                onClick={getOnDonateButtonClick('pledge', offlineMethod.method)}
              >
                {offlineMethod.label}
              </button>
            </div>
          )
      )}
    </>
  );
};
